import { SuggestionNavigationService } from './suggestionNavigation';

export const SuggestionNavigationServiceSingleton = new SuggestionNavigationService();
